export default "__VITE_ASSET__CXhnbiMs__"